import { motion } from "framer-motion";
import React from "react";

export interface INavShadowProps {
  onClick: React.MouseEventHandler<HTMLDivElement>;
  className?: string;
}

function NavShadow(props: INavShadowProps) {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 0.5 }}
      exit={{ opacity: 0 }}
      transition={{ ease: "easeOut", duration: 0.2 }}
      key="mylistsshadow"
      className={"nav-menu-shadow " + props.className}
      onClick={props.onClick}
    ></motion.div>
  );
}

export default NavShadow;
